import { flatTransformKeys } from 'cio/utils/objects';
import Transform from 'ember-data/transform';
import { decamelize, camelize } from '@ember/string';
import { EnvironmentUsage } from 'cio/utils/billing/usage';

interface SerializedEnvironmentUsage {
  environment_id: number;
  billed: boolean;
  customers_total: number;
  customers_churn: number;
  objects_total: number;
  objects_churn: number;
}

export default class AccountEnvironmentUsageTransform extends Transform {
  deserialize(serialized: SerializedEnvironmentUsage[] | null) {
    if (serialized == null) {
      return [];
    }

    return serialized.map((usage) => {
      let deserialized = flatTransformKeys(usage, camelize);
      deserialized.highWatermarkCustomersTotal =
        (deserialized.customersTotal ?? 0) + (deserialized.customersChurn ?? 0);
      return deserialized;
    });
  }

  serialize(deserialized: EnvironmentUsage[] | null) {
    if (deserialized == null) {
      return [];
    }

    return deserialized.map((usage) => {
      let serialized = flatTransformKeys(usage, decamelize);
      delete serialized.highWatermarkCustomersTotal;
      return serialized;
    });
  }
}

declare module 'ember-data/types/registries/transform' {
  export default interface TransformRegistry {
    'account/environment-usage': EnvironmentUsage[] | null;
  }
}
